module.exports = __webpack_public_path__ + "img/banner-19.a633b7c9.jpg";